import type { FeatureFlags } from "../flags";

export interface Me {
  email: string;
  isAdmin?: boolean;
  impersonatedBy?: string | null; // impersonating admin's email; null/absent normally
  plan: string;
  credits: number;
  usage: { recordings: number; chatOutputTokens: number };
  limits: { minutesPerRecording: number | null };
  flags?: FeatureFlags; // resolved feature flags (see src/flags.ts)
}

// Small read-only usage meter for the current user: credit balance plus the
// plan's per-recording length cap. Fed by /api/me.
export function UsageBadge({ me }: { me: Me | null }) {
  if (!me) return null;
  return (
    <div className="usage-badge">
      <div className="usage-plan">{me.plan} plan</div>
      <div className="usage-row">
        <span>credits</span>
        <span>{me.credits.toLocaleString("en-US")}</span>
      </div>
      <div className="usage-row">
        <span>max recording</span>
        <span>{me.limits.minutesPerRecording == null ? "∞" : `${me.limits.minutesPerRecording} min`}</span>
      </div>
    </div>
  );
}
